import Page from "webPage/Page";
import StickySection from "util/StickySection";

import {handleScrollingSection} from "util/scrolling-section";
import Quote from "util/Quote";

Page.register('page-template-get-a-quote', () => {
    if ($('.measurement').length > 1) {
        new StickySection($('.js-sticky-section'), 760);
    }

    handleScrollingSection($(".js-rating-track-wrap"), 0, 1199);

    if ($('.js-quote').length === 1) {
        new Quote($('.js-quote'));
    }

    $('body').on('click', '.js-view-opening-hours-btn',function(){
        $('.js-opening-times-modal').addClass('modal--active');
        $('body').addClass('modal-active');
    }).on('click', '.js-close-modal', function(){
       $(this).closest('.modal').removeClass('modal--active');
        $('body').removeClass('modal-active');
    });
});
